import React, { useState } from 'react';
import { 
    Table, ConfigProvider, theme, Dropdown, Avatar, 
    Modal, Drawer, Form, Input, DatePicker, Select, Button, Space 
} from 'antd';
import {
    SlidersHorizontal, LayoutTemplate, Download, Upload, Settings,
    ChevronLeft, ChevronRight, CornerUpLeft, FileText, Trash2, ChevronDown, Plus,
    CheckCircle, FileSignature, ListChecks, Link as LinkIcon, Pencil, QrCode, FileDown
} from 'lucide-react';
import Layout from '../../Layout';
import { Link, useNavigate } from 'react-router-dom';

// ================= 1. DỮ LIỆU MẪU (MOCK DATA) =================
const flatData = [
    { key: '1', name: '1tesst', code: 'BBBG_115', receiver: 'Lê Hòa Bình', date: '25/06/2026', qty: 1, createDate: '25/06/2026', creator: { name: 'B', color: '#a1a1aa' } },
    { key: '2', name: 'Đồng phục', code: 'BBBG_114', receiver: 'Test TACO', date: '10/07/2026', qty: 1, createDate: '25/06/2026', creator: { name: 'N', color: '#4ade80' } },
    { key: '3', name: 'TEST - NTHQ', code: 'BBBG_113', receiver: 'Lê Quang Hưng', date: '20/05/2026', qty: 2, createDate: '20/05/2026', creator: { name: 'N', color: '#4ade80' } },
    { key: '4', name: 'CẤP PHÁT TÀI SẢN ONBOARDING - NTHQ', code: 'BBBG_112', receiver: 'Quintessa Nguyễn', date: '21/05/2026', qty: 2, createDate: '20/05/2026', creator: { name: 'N', color: '#4ade80' } },
    { key: '5', name: 'Test', code: 'BBBG_111', receiver: 'Lê Quang Hưng', date: '21/05/2026', qty: 1, createDate: '20/05/2026', creator: { name: 'H', color: '#a3e635' } },
    { key: '6', name: 'Máy tính deal', code: 'BBBG_110', receiver: 'Trần Diễm Quỳnh ka', date: '13/05/2026', qty: 1, createDate: '13/05/2026', creator: { img: 'https://i.pravatar.cc/150?u=1' } },
    { key: '7', name: 'Laptop 1', code: 'BBBG_109', receiver: 'Lê Thu Trang', date: '31/03/2026', qty: 1, createDate: '31/03/2026', creator: { img: 'https://i.pravatar.cc/150?u=2' } },
    { key: '8', name: 'Máy bơm tiêm điện', code: 'BBBG_108', receiver: 'NTTT3', date: '31/03/2026', qty: 1, createDate: '31/03/2026', creator: { img: 'https://i.pravatar.cc/150?u=3' } },
    { key: '9', name: 'Dao mổ điện cao tần Plasma', code: 'BBBG_107', receiver: 'GGM Phó Tổng Giám Đốc Kinh Doanh', date: '02/02/2026', qty: 1, createDate: '04/02/2026', creator: { name: '1', color: '#3e91ab' } },
    { key: '10', name: 'Iphone 6', code: 'BBBG_106', receiver: 'GGM Phó Tổng Giám Đốc Kinh Doanh', date: '04/02/2026', qty: 1, createDate: '04/02/2026', creator: { name: '1', color: '#3e91ab' } },
    { key: '11', name: 'Ốc', code: 'BBBG_105', receiver: 'Cuong Tran', date: '28/01/2026', qty: 1, createDate: '28/01/2026', creator: { name: '1', color: '#3e91ab' } },
    { key: '12', name: 'Cấp phát laptop Macbook_1234', code: 'BBBG_104', receiver: 'Phương Văn Thịnh', date: '30/12/2025', qty: 1, createDate: '30/12/2025', creator: { name: '1', color: '#3e91ab' } },
    { key: '13', name: 'Máy tính', code: 'BBBG_103', receiver: 'Hà Anh', date: '27/12/2025', qty: 1, createDate: '29/12/2025', creator: { name: '1', color: '#3e91ab' } },
];

const TAB_CONFIGS = [
    { key: 'all', label: 'Tất cả', count: 105 },
    { key: 'allocating', label: 'Đang cấp phát', count: 71 },
    { key: 'recalling', label: 'Đang thu hồi', count: 8 },
    { key: 'recalled', label: 'Thu hồi xong', count: 26 },
    { key: 'transfer', label: 'Điều chuyển', count: 4 },
];

const THEME_COLOR = '#3e91ab';

export default function AllocationList() {
    const navigate = useNavigate();
    
    const [isDarkMode, setIsDarkMode] = useState(false);
    const [activeTab, setActiveTab] = useState('all');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    // ================= STATE QUẢN LÝ RIGHT-CLICK MENU VÀ MODAL DEMO =================
    const [popup, setPopup] = useState({ visible: false, x: 0, y: 0, record: null });
    
    const [actionModals, setActionModals] = useState({
        confirmIssue: false,
        edit: false,
        delete: false
    });

    const rightClickMenuItems = [
        { key: 'approve', icon: <CheckCircle size={16} className="text-gray-500" />, label: 'Duyệt điều chuyển' },
        { key: 'sign', icon: <FileSignature size={16} className="text-gray-500" />, label: 'Tạo hồ sơ ký số' },
        { type: 'divider' },
        { key: 'confirm_issue', icon: <ListChecks size={16} className="text-gray-500" />, label: 'Xác nhận cấp phát tài sản' },
        { key: 'link_object', icon: <LinkIcon size={16} className="text-gray-500" />, label: 'Liên kết đối tượng liên quan' },
        { type: 'divider' },
        { 
            key: 'form', 
            icon: <FileText size={16} className="text-gray-500" />, 
            label: 'Biểu mẫu',
            children: [
                { 
                    key: 'qrcode', 
                    label: 'Qrcode',
                    icon: <QrCode size={16} className="text-gray-500" />,
                    children: [
                        { key: 'export', label: 'Xuất file', icon: <FileDown size={16} className="text-gray-500" /> }
                    ]
                }
            ]
        },
        { key: 'edit', icon: <Pencil size={16} className="text-gray-500" />, label: 'Sửa' },
        { key: 'delete', icon: <Trash2 size={16} className="text-gray-500" />, label: 'Xóa' },
        { type: 'divider' },
        { key: 'customize', icon: <Settings size={16} className="text-gray-500" />, label: 'Tùy chỉnh' },
    ];

    const handleRightClickAction = ({ key }) => {
        setPopup({ ...popup, visible: false });
        
        if (key === 'sign') {
            // Điều hướng sang tạo hồ sơ ký số
            navigate(`/submit-for-signature/add${popup.record ? `?id=${popup.record.key}` : ''}`);
        } else if (key === 'edit') {
            // Điều hướng sang trang sửa với ID bản ghi
            navigate(`/assets/edit`);
        } else if (key === 'confirm_issue') {
            setActionModals({ ...actionModals, confirmIssue: true });
        } else if (key === 'delete') {
            setActionModals({ ...actionModals, delete: true });
        }
    };

    // ================= 2. ĐỊNH NGHĨA CỘT =================
    const columns = [
        {
            title: 'Tên cấp phát',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <span className="text-gray-700 dark:text-gray-200 font-medium">{text}</span>
        },
        { title: 'Mã CP', dataIndex: 'code', key: 'code', render: (text) => <span className="text-gray-600 dark:text-gray-300">{text}</span> },
        { title: 'Nhân sự nhận', dataIndex: 'receiver', key: 'receiver', render: (text) => <span className="text-gray-600 dark:text-gray-300">{text}</span> },
        { title: 'Ngày cấp', dataIndex: 'date', key: 'date', align: 'center', render: (text) => <span className="text-gray-600 dark:text-gray-300">{text}</span> },
        { title: 'Số lượng', dataIndex: 'qty', key: 'qty', align: 'center', render: (text) => <span className="text-gray-600 dark:text-gray-300">{text}</span> },
        { title: 'Ngày tạo', dataIndex: 'createDate', key: 'createDate', align: 'center', render: (text) => <span className="text-gray-600 dark:text-gray-300">{text}</span> },
        {
            title: 'Người tạo',
            dataIndex: 'creator',
            key: 'creator',
            align: 'center',
            render: (creator) => {
                if (creator.img) {
                    return <Avatar size={26} src={creator.img} className="border border-gray-200" />;
                }
                return (
                    <Avatar size={26} style={{ backgroundColor: creator.color }} className="text-[11px] font-semibold">
                        {creator.name}
                    </Avatar>
                );
            }
        },
    ];

    // ================= 3. RENDER =================
    return (
        <Layout>
            <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-6 shrink-0 gap-4">
                <div>
                    <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">Danh sách cấp phát</h1>
                </div>
                <button className="flex items-center gap-2 px-3 py-1.5 bg-[#3e91ab] text-white rounded text-sm font-medium hover:bg-[#357f96] transition-colors max-w-[120px]" onClick={() => navigate(`/assets/allocation-add`)}>
                    <Plus size={16} /> Thêm mới
                </button>
            </div>

            <div className="bg-white dark:bg-gray-900 min-h-screen relative flex flex-col">
                {/* HEADER - TABS */}
                <div className="flex items-center border-b border-gray-200 dark:border-gray-800 px-6 pt-4 overflow-x-auto no-scrollbar">
                    <div className="flex space-x-8 min-w-max">
                        {TAB_CONFIGS.map(tab => (
                            <button
                                key={tab.key}
                                onClick={() => setActiveTab(tab.key)}
                                className={`pb-3 text-[14px] font-medium border-b-2 whitespace-nowrap transition-colors ${activeTab === tab.key
                                    ? 'border-[#3e91ab] text-[#3e91ab]'
                                    : 'border-transparent text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200'
                                    }`}
                            >
                                {tab.label} ({tab.count})
                            </button>
                        ))}
                    </div>
                </div>

                {/* TOOLBAR - THAY ĐỔI ĐỘNG DỰA VÀO CHECKBOX */}
                <div className="flex flex-col border-b border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-900">
                    
                    {/* KHỐI 1: HIỆN LÊN KHI CÓ CHECKBOX ĐƯỢC CHỌN */}
                    {selectedRowKeys.length > 0 && (
                        <div className="flex items-center px-4 py-2 bg-blue-50/50 dark:bg-gray-800/50 border-b border-gray-100 dark:border-gray-700 animate-in fade-in duration-200 overflow-x-auto no-scrollbar">
                            <div className="flex items-center gap-4 md:gap-6 min-w-max">
                                <button className="flex items-center text-[13px] font-medium text-gray-600 hover:text-[#3e91ab] transition-colors whitespace-nowrap">
                                    <CornerUpLeft size={16} className="mr-1.5 shrink-0" /> Thu hồi
                                </button>
                                <Dropdown menu={{ items: [{ key: '1', label: 'Mẫu bàn giao' }] }} trigger={['click']}>
                                    <button className="flex items-center text-[13px] font-medium text-gray-600 hover:text-[#3e91ab] transition-colors whitespace-nowrap">
                                        <FileText size={16} className="mr-1.5 shrink-0" /> Biểu mẫu <ChevronDown size={14} className="ml-1 shrink-0" />
                                    </button>
                                </Dropdown>
                                <button className="flex items-center text-[13px] font-medium text-gray-600 hover:text-red-500 transition-colors whitespace-nowrap">
                                    <Trash2 size={16} className="mr-1.5 shrink-0" /> Xóa
                                </button>
                                <button className="flex items-center text-[13px] font-medium text-gray-600 hover:text-[#3e91ab] transition-colors whitespace-nowrap">
                                    <Download size={16} className="mr-1.5 shrink-0" /> Export
                                </button>
                            </div>
                        </div>
                    )}

                    {/* KHỐI 2: TOOLBAR TIÊU CHUẨN */}
                    <div className="flex justify-between items-center px-4 py-3 overflow-x-auto no-scrollbar">
                        <div className="flex items-center gap-3 shrink-0 min-w-max">
                            <SlidersHorizontal size={16} className="text-gray-400 cursor-pointer hover:text-[#3e91ab]" />
                            <LayoutTemplate size={16} className="text-gray-400 cursor-pointer hover:text-[#3e91ab]" />
                            
                            <div className="w-px h-4 bg-gray-300 mx-1"></div>
                            
                            {selectedRowKeys.length > 0 ? (
                                <span className="text-[13px] text-gray-600">
                                    Đã chọn <b className="text-gray-800">{selectedRowKeys.length}</b> bản ghi
                                </span>
                            ) : (
                                <span className="text-[13px] text-gray-500">
                                    Hiển thị 1 - 50 / 105 bản ghi
                                </span>
                            )}

                            <span className="text-[13px] text-gray-500 ml-4 flex items-center gap-1 cursor-pointer hover:text-gray-700">
                                Trang: 01 / 03 <ChevronDown size={14} />
                            </span>
                            
                            <div className="flex items-center gap-2 ml-2">
                                <ChevronLeft size={16} className="text-gray-300 cursor-not-allowed" />
                                <ChevronRight size={16} className="text-gray-500 cursor-pointer hover:text-gray-800" />
                            </div>
                        </div>

                        {selectedRowKeys.length === 0 && (
                            <div className="flex items-center space-x-6 shrink-0 min-w-max ml-4 animate-in fade-in">
                                <button className="flex items-center text-[13px] font-medium text-gray-600 hover:text-[#3e91ab] transition-colors">
                                    <Download size={15} className="mr-1.5 text-gray-400" /> Export
                                </button>
                                <button className="flex items-center text-[13px] font-medium text-gray-600 hover:text-[#3e91ab] transition-colors">
                                    <Upload size={15} className="mr-1.5 text-gray-400" /> Import
                                </button>
                                <button className="flex items-center text-[13px] font-medium text-gray-600 hover:text-[#3e91ab] transition-colors">
                                    <Settings size={15} className="mr-1.5 text-gray-400" /> Cài đặt
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                {/* BẢNG DỮ LIỆU */}
                <div 
                    className="flex-1 overflow-hidden relative"
                    onClick={() => { if (popup.visible) setPopup({ ...popup, visible: false }) }}
                >
                    <ConfigProvider
                        theme={{
                            algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
                            token: {
                                colorPrimary: THEME_COLOR, 
                            },
                            components: {
                                Table: {
                                    headerBg: isDarkMode ? '#1f2937' : '#ffffff',
                                    headerColor: isDarkMode ? '#9ca3af' : '#6b7280',
                                    cellPaddingBlock: 12,
                                    rowHoverBg: isDarkMode ? '#374151' : '#f9fafb',
                                    borderColor: isDarkMode ? '#374151' : '#f3f4f6'
                                },
                            },
                        }}
                    >
                        <Table
                            rowSelection={{
                                selectedRowKeys,
                                onChange: setSelectedRowKeys,
                            }}
                            columns={columns}
                            dataSource={flatData}
                            pagination={false}
                            scroll={{ x: 'max-content' }}
                            rowClassName={(record) => selectedRowKeys.includes(record.key) ? 'bg-blue-50/20 cursor-pointer' : 'bg-transparent text-[13.5px] cursor-pointer'}
                            
                            // THÊM SỰ KIỆN onRow Ở ĐÂY
                            onRow={(record) => ({
                                // Xử lý khi click vào dòng
                                onClick: () => {
                                    navigate('/assets/allocation-detail');
                                    // Hoặc nếu bạn muốn truyền kèm ID của bản ghi:
                                    // navigate(`/assets/allocation-detail?id=${record.key}`);
                                },
                                // Giữ nguyên sự kiện chuột phải (nếu có)
                                onContextMenu: (e) => {
                                    e.preventDefault();
                                    e.stopPropagation(); 
                                    setPopup({
                                        visible: true,
                                        x: e.clientX,
                                        y: e.clientY,
                                        record: record,
                                    });
                                },
                            })}
                        />
                    </ConfigProvider>

                    {/* MỎ NEO HIỂN THỊ MENU CHUỘT PHẢI */}
                    {popup.visible && (
                        <Dropdown
                            menu={{ 
                                items: rightClickMenuItems, 
                                onClick: handleRightClickAction 
                            }}
                            open={popup.visible}
                            onOpenChange={(visible) => {
                                if (!visible) setPopup({ ...popup, visible: false });
                            }}
                            trigger={['contextMenu']}
                        >
                            <div style={{ position: 'fixed', left: popup.x, top: popup.y, zIndex: 9999, width: 1, height: 1 }} />
                        </Dropdown>
                    )}
                </div>

                {/* ================= CÁC MODAL/DRAWER CHO DEMO ================= */}

                {/* 1. Modal Xác nhận cấp phát tài sản */}
                <Modal
                    title={<span className="font-semibold text-gray-800">Xác nhận cấp phát tài sản</span>}
                    open={actionModals.confirmIssue}
                    onCancel={() => setActionModals({ ...actionModals, confirmIssue: false })}
                    footer={[
                        <Button key="cancel" onClick={() => setActionModals({ ...actionModals, confirmIssue: false })}>
                            HỦY BỎ
                        </Button>,
                        <Button key="submit" type="primary" className="bg-[#3e91ab] hover:bg-[#3e91ab] border-none">
                            CẬP NHẬT
                        </Button>,
                    ]}
                    width={600}
                >
                    <div className="mt-4 border border-gray-200 rounded-md overflow-hidden">
                        <Table
                            size="small"
                            pagination={false}
                            rowSelection={{ type: 'checkbox' }}
                            columns={[
                                { title: 'Mã TS', dataIndex: 'maTS' },
                                { title: 'Tài sản', dataIndex: 'taiSan' },
                                { title: 'Số lượng', dataIndex: 'soLuong' },
                                { title: 'Tên người nhận', dataIndex: 'nguoiNhan' },
                            ]}
                            dataSource={[
                                { key: '1', maTS: 'TS.164', taiSan: 'Máy tính', soLuong: 1, nguoiNhan: popup.record?.receiver || 'bbb' }
                            ]}
                        />
                    </div>
                </Modal>

                {/* 2. Drawer Sửa cấp phát */}
                <Drawer
                    title={<span className="font-semibold text-gray-800">Sửa cấp phát tài sản</span>}
                    width={650}
                    onClose={() => setActionModals({ ...actionModals, edit: false })}
                    open={actionModals.edit}
                    extra={
                        <Space>
                            <Button onClick={() => setActionModals({ ...actionModals, edit: false })}>HỦY BỎ</Button>
                            <Button type="primary" className="bg-[#3e91ab] hover:bg-[#3e91ab] border-none">CẬP NHẬT</Button>
                        </Space>
                    }
                >
                    <Form layout="vertical" className="space-y-4">
                        <h3 className="text-orange-500 font-medium border-b pb-2 mb-4">Thông tin chung</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item label="Mã CP">
                                <Input defaultValue={popup.record?.code} disabled />
                            </Form.Item>
                            <Form.Item label="Nhập tên cấp phát" required>
                                <Input defaultValue={popup.record?.name} />
                            </Form.Item>
                        </div>
                        <Form.Item label="Cấp phát cho">
                            <Select defaultValue="CaNhan" options={[{ value: 'CaNhan', label: 'Cá nhân' }]} />
                        </Form.Item>
                        <Form.Item label="Người cấp phát">
                            <Select defaultValue="admin" options={[{ value: 'admin', label: 'NS999 - Admin Hệ Thống' }]} disabled />
                        </Form.Item>
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item label="Ngày cấp phát" required>
                                <DatePicker className="w-full" />
                            </Form.Item>
                            <Form.Item label="Thời gian cấp phát" required>
                                <Input defaultValue="15:00" />
                            </Form.Item>
                        </div>
                        <Form.Item label="Địa điểm bàn giao">
                            <Input placeholder="Nhập địa điểm bàn giao" />
                        </Form.Item>
                        <h3 className="text-orange-500 font-medium border-b pb-2 mb-4 mt-6">Tài sản</h3>
                        <div className="p-3 border border-gray-200 rounded-md flex gap-2 items-center bg-gray-50">
                            <Input defaultValue="TS.164 - Máy tính" className="flex-1" />
                            <Input defaultValue="1" style={{ width: '80px' }} />
                            <Select defaultValue="ViTri" style={{ width: '120px' }} options={[{ value: 'ViTri', label: 'Chọn Vị trí' }]} />
                            <Input placeholder="Nhận đặt cọc" style={{ width: '120px' }} />
                            <Input defaultValue={popup.record?.receiver || ''} className="flex-1" />
                        </div>
                    </Form>
                </Drawer>

                {/* 3. Modal Xác nhận Xóa */}
                <Modal
                    title="Xác nhận"
                    open={actionModals.delete}
                    onCancel={() => setActionModals({ ...actionModals, delete: false })}
                    footer={[
                        <Button key="submit" type="primary" className="bg-[#3e91ab] hover:bg-[#3e91ab] border-none" onClick={() => setActionModals({ ...actionModals, delete: false })}>
                            ĐỒNG Ý
                        </Button>,
                        <Button key="cancel" onClick={() => setActionModals({ ...actionModals, delete: false })}>
                            HỦY BỎ
                        </Button>,
                    ]}
                    width={400}
                    centered
                >
                    <p className="text-gray-600 text-[15px] py-4">Bạn có chắc muốn xóa bản ghi này?</p>
                </Modal>

                {/* CSS CUSTOM */}
                <style dangerouslySetInnerHTML={{
                    __html: `
                    /* Ẩn thanh cuộn */
                    .no-scrollbar::-webkit-scrollbar { display: none; }
                    .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
                    
                    /* Ẩn dấu kẻ dọc mặc định của Table Antd */
                    .ant-table-thead > tr > th::before {
                        display: none !important; 
                    }
                        
                    /* --- TÙY CHỈNH DROPDOWN CHO THOÁNG VÀ CANH GIỮA ICON --- */
                    .ant-dropdown .ant-dropdown-menu-item, 
                    .ant-dropdown-menu-submenu-title {
                        padding-top: 10px !important;
                        padding-bottom: 10px !important;
                        display: flex !important;
                        align-items: center !important;
                    }
                    .ant-dropdown .ant-dropdown-menu-item .lucide,
                    .ant-dropdown .ant-dropdown-menu-submenu-title .lucide {
                        margin-right: 8px !important;
                    }
                `}} />

            </div>
        </Layout>
    );
}